import { useEffect, useState } from "react"
import { Card, Spinner } from "react-bootstrap"
import { useSnapshot } from "valtio"
import { engagementStore } from "src/modules/engagement/engagementStore"
import { NotebookService } from "@services/notebook/notebookService"
import { formatNoteDate } from "@/shared/utils/noteDate"

interface NoteItem {
  id: number
  title: string
  create_date?: string | null
}

const RecentNotes = () => {
  const engagementSnap = useSnapshot(engagementStore)
  const [notes, setNotes] = useState<NoteItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const notebookId = engagementSnap.selectedEngagement.notebook?.id
    if (!notebookId || notebookId === -1) {
      setIsLoading(false)
      return
    }

    (async () => {
      try {
        const service = new NotebookService()
        const response = await service.getNotes(notebookId, null)
        const sorted = [...response].sort((a: NoteItem, b: NoteItem) => b.id - a.id)
        setNotes(sorted)
      } catch (error) {
        console.error("Error fetching notes:", error)
      } finally {
        setIsLoading(false)
      }
    })()
  }, [engagementSnap.selectedEngagement.notebook?.id])

  return (
    <Card className="custom-card overflow-hidden h-100 border-0 mb-0">
      <Card.Body className="p-0 d-flex h-100 flex-column">
        <div className="p-3 pb-0">
          <span className="d-block fw-semibold fs-15">Recent Notes</span>
        </div>
        <div className="p-3 pt-2 flex-grow-1 overflow-auto">
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center py-3">
              <Spinner animation="border" size="sm" className="text-primary" />
            </div>
          ) : notes.length === 0 ? (
            <span className="text-muted fs-12">No notes found</span>
          ) : (
            <ul className="list-unstyled mb-0">
              {notes.map((note, index) => (
                <li
                  key={note.id}
                  className={`py-3${index < notes.length - 1 ? " border-bottom" : ""}`}
                >
                  {/* When, then what (MPN-1640). A tile of bare titles cannot answer
                      "what changed on this campaign and when", which is the only reason
                      to glance at it from the Monitor page -- Ops had started typing the
                      date into the title to make up for it. Same format as the Notes
                      page, from the same helper. */}
                  {formatNoteDate(note.create_date) && (
                    <span className="fs-11 text-muted d-block">
                      {formatNoteDate(note.create_date)}
                    </span>
                  )}
                  <span className="fs-13 text-truncate d-block">{note.title}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}

export default RecentNotes
